(function () {
  function formatReviewCount(count, locale) {
    var normalizedLocale = (locale || "").toLowerCase();

    if (normalizedLocale.indexOf("pl") === 0) {
      var mod10 = count % 10;
      var mod100 = count % 100;

      if (count === 1) {
        return "1 opinia";
      }

      if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
        return count + " opinie";
      }

      return count + " opinii";
    }

    return count === 1 ? "1 review" : count + " reviews";
  }

  function formatDate(locale, value) {
    return new Intl.DateTimeFormat(locale || "pl-PL", {
      dateStyle: "medium",
    }).format(new Date(value));
  }

  function joinOrderedItems(items) {
    return (items || [])
      .map(function (item) {
        return item.productTitle + " x" + item.quantity;
      })
      .join(", ");
  }

  function createBadge(label, className) {
    var badge = document.createElement("span");
    badge.className = className;
    badge.textContent = label;
    return badge;
  }

  function normalizeErrorMessage(error, fallback) {
    var message = error && error.message ? String(error.message) : "";

    if (!message) {
      return fallback;
    }

    var normalizedMessage = message.toLowerCase();

    if (
      message === "The string did not match the expected pattern." ||
      normalizedMessage.indexOf("unexpected end of json input") !== -1 ||
      normalizedMessage.indexOf("failed to fetch") !== -1 ||
      normalizedMessage.indexOf("networkerror") !== -1 ||
      normalizedMessage.indexOf("invalid_json_response") !== -1 ||
      normalizedMessage.indexOf("reviews_unavailable") !== -1 ||
      normalizedMessage.indexOf("unable to load reviews") !== -1 ||
      normalizedMessage.indexOf("unable to submit review") !== -1
    ) {
      return fallback;
    }

    return message;
  }

  async function parseJsonResponse(response) {
    var responseText = await response.text();

    if (!responseText) {
      return null;
    }

    try {
      return JSON.parse(responseText);
    } catch (error) {
      throw new Error("INVALID_JSON_RESPONSE");
    }
  }

  function createReviewCard(review, locale, labels) {
    var article = document.createElement("article");
    article.className = "product-reviews__item";

    var header = document.createElement("div");
    header.className = "product-reviews__item-header";

    var meta = document.createElement("div");
    var badgeRow = document.createElement("div");
    badgeRow.className = "product-reviews__item-badges";

    if (review.verifiedPurchase) {
      badgeRow.appendChild(
        createBadge(
          labels.verifiedPurchase || "Potwierdzony zakup",
          "product-reviews__item-badge product-reviews__item-badge--verified",
        ),
      );
    }

    if (review.targetType === "STORE") {
      badgeRow.appendChild(
        createBadge(
          "Opinia o sklepie",
          "product-reviews__item-badge product-reviews__item-badge--type",
        ),
      );
    }

    if (badgeRow.children.length > 0) {
      meta.appendChild(badgeRow);
    }

    var author = document.createElement("strong");
    author.textContent = review.authorName;
    meta.appendChild(author);

    var metaLine = document.createElement("div");
    metaLine.className = "product-reviews__item-meta";
    metaLine.textContent = formatDate(locale, review.approvedAt || review.createdAt);

    if (review.orderName) {
      metaLine.textContent += " • " + review.orderName;
    }

    meta.appendChild(metaLine);

    if (review.orderedItems && review.orderedItems.length > 0) {
      var orderLine = document.createElement("div");
      orderLine.className = "product-reviews__item-order";
      orderLine.textContent = joinOrderedItems(review.orderedItems);
      meta.appendChild(orderLine);
    }

    header.appendChild(meta);

    var rating = document.createElement("span");
    rating.className = "product-reviews__item-rating";
    rating.textContent = review.rating + "/5";
    header.appendChild(rating);
    article.appendChild(header);

    if (review.title) {
      var title = document.createElement("p");
      title.className = "product-reviews__item-title h6";
      title.textContent = review.title;
      article.appendChild(title);
    }

    var body = document.createElement("p");
    body.className = "product-reviews__item-body";
    body.textContent = review.body;
    article.appendChild(body);

    if (review.reply && review.reply.body) {
      var reply = document.createElement("div");
      reply.className = "product-reviews__reply";

      var replyTitle = document.createElement("strong");
      replyTitle.textContent =
        review.reply.authorName || labels.storeReply || "Odpowiedz sklepu";
      reply.appendChild(replyTitle);

      var replyDate = document.createElement("div");
      replyDate.className = "product-reviews__reply-meta";
      replyDate.textContent = formatDate(locale, review.reply.createdAt);
      reply.appendChild(replyDate);

      var replyBody = document.createElement("p");
      replyBody.className = "product-reviews__reply-body";
      replyBody.textContent = review.reply.body;
      reply.appendChild(replyBody);

      article.appendChild(reply);
    }

    return article;
  }

  function ReviewsSection(root) {
    this.root = root;
    this.locale = root.dataset.locale || document.documentElement.lang || "pl-PL";
    this.reviewsUrl = root.dataset.productReviewsUrl;
    this.targetType = root.dataset.reviewTarget || "product";
    this.productId = root.dataset.productId || "";
    this.noReviewsLabel = root.dataset.labelNoReviews || "Ten produkt nie ma jeszcze opinii.";
    this.noRatingLabel = root.dataset.labelNoRating || "Brak ocen";
    this.labels = {
      verifiedPurchase: root.dataset.labelVerifiedPurchase || "Potwierdzony zakup",
      storeReply: root.dataset.labelStoreReply || "Odpowiedz sklepu",
      headerIneligibleNote:
        root.dataset.labelHeaderIneligibleNote ||
        "Wszystkie opinie sa potwierdzone zakupem. Ocene produktu moga dodac tylko zalogowani klienci po realizacji zamowienia.",
      formNote:
        root.dataset.labelFormNote || "Wszystkie opinie sa potwierdzone zakupem.",
      eligibilityLoginRequired:
        root.dataset.labelEligibilityLoginRequired ||
        "Mozliwosc dodania opinii wymaga zalozenia konta. Formularz pojawi sie po realizacji zamowienia.",
      eligibilityEligible:
        root.dataset.labelEligibilityEligible ||
        "Opinie publikujemy po weryfikacji. Wystawisz je tylko dla oplaconego i zrealizowanego zakupu.",
      moduleUnavailable:
        root.dataset.labelModuleUnavailable || "Modul opinii jest chwilowo niedostepny.",
      loadError:
        root.dataset.labelLoadError ||
        "Nie udalo sie zaladowac opinii. Sprobuj ponownie za chwile.",
      submitError:
        root.dataset.labelSubmitError ||
        "Nie udalo sie wyslac opinii. Sprobuj ponownie za chwile.",
    };
    this.loadingNode = root.querySelector("[data-review-loading]");
    this.headerNoteNode = root.querySelector("[data-review-header-note]");
    this.emptyBannerNode = root.querySelector("[data-review-empty-banner]");
    this.listNode = root.querySelector("[data-review-list]");
    this.listWrapperNode = root.querySelector("[data-review-list-wrapper]");
    this.feedbackNode = root.querySelector("[data-review-feedback]");
    this.summaryAverageNode = root.querySelector("[data-review-summary-average]");
    this.summaryCountNode = root.querySelector("[data-review-summary-count]");
    this.distributionNode = root.querySelector("[data-review-distribution]");
    this.summaryCardNode = root.querySelector("[data-review-summary-card]");
    this.formCardNode = root.querySelector("[data-review-form-card]");
    this.cardNoteNode = root.querySelector("[data-review-card-note]");
    this.loadMoreWrapper = root.querySelector("[data-review-load-more-wrapper]");
    this.loadMoreButton = root.querySelector("[data-review-load-more]");
    this.sortWrapper = root.querySelector("[data-review-sort-wrapper]");
    this.sortSelect = root.querySelector("[data-review-sort]");
    this.eligibilityMessageNode = root.querySelector("[data-review-eligibility-message]");
    this.formNode = root.querySelector("[data-review-form]");
    this.formContainer = root.querySelector("[data-review-form-container]");
    this.orderField = root.querySelector("[data-review-order-field]");
    this.orderSelect = root.querySelector("[data-review-order-select]");
    this.orderHint = root.querySelector("[data-review-order-hint]");
    this.nextOffset = 0;
    this.activeSort = this.sortSelect ? this.sortSelect.value : "latest";
    this.eligibleOrders = [];
    this.isLoaded = false;
    this.isLoading = false;
    this.bind();
    this.observe();
  }

  ReviewsSection.prototype.bind = function () {
    var _this = this;

    if (this.formNode) {
      this.formNode.addEventListener("submit", function (event) {
        event.preventDefault();
        _this.submit();
      });
    }

    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener("click", function () {
        _this.fetchReviews(true);
      });
    }

    if (this.sortSelect) {
      this.sortSelect.addEventListener("change", function () {
        _this.activeSort = _this.sortSelect.value || "latest";
        _this.fetchReviews(false);
      });
    }

    if (this.orderSelect) {
      this.orderSelect.addEventListener("change", function () {
        _this.updateOrderHint();
      });
    }
  };

  ReviewsSection.prototype.observe = function () {
    var _this = this;

    if (!("IntersectionObserver" in window)) {
      this.fetchReviews(false);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            _this.fetchReviews(false);
          }
        });
      },
      { rootMargin: "200px 0px" },
    );

    observer.observe(this.root);
  };

  ReviewsSection.prototype.setFeedback = function (message, tone) {
    if (!this.feedbackNode) {
      return;
    }

    this.feedbackNode.textContent = message;
    this.feedbackNode.dataset.tone = tone;
    this.feedbackNode.removeAttribute("hidden");
  };

  ReviewsSection.prototype.clearFeedback = function () {
    if (!this.feedbackNode) {
      return;
    }

    this.feedbackNode.textContent = "";
    this.feedbackNode.dataset.tone = "";
    this.feedbackNode.setAttribute("hidden", "");
  };

  ReviewsSection.prototype.updateReviewVisibility = function (count) {
    var hasReviews = Number(count) > 0;

    this.root.dataset.reviewHasReviews = hasReviews ? "true" : "false";

    if (this.summaryCardNode) {
      if (hasReviews) {
        this.summaryCardNode.removeAttribute("hidden");
      } else {
        this.summaryCardNode.setAttribute("hidden", "");
      }
    }

    if (this.emptyBannerNode) {
      if (hasReviews) {
        this.emptyBannerNode.setAttribute("hidden", "");
      } else {
        this.emptyBannerNode.removeAttribute("hidden");
      }
    }

    if (this.listWrapperNode) {
      if (hasReviews) {
        this.listWrapperNode.removeAttribute("hidden");
      } else {
        this.listWrapperNode.setAttribute("hidden", "");
      }
    }
  };

  ReviewsSection.prototype.resolveEligibilityMessage = function (eligibility) {
    if (!eligibility) {
      return "";
    }

    if (eligibility.reason === "login_required") {
      return this.labels.eligibilityLoginRequired;
    }

    if (eligibility.reason === "eligible") {
      return this.labels.eligibilityEligible;
    }

    return eligibility.message || "";
  };

  ReviewsSection.prototype.resolveHeaderNote = function (eligibility) {
    if (!eligibility) {
      return this.labels.headerIneligibleNote;
    }

    if (
      eligibility.reason === "login_required" ||
      eligibility.reason === "awaiting_purchase"
    ) {
      return this.labels.headerIneligibleNote;
    }

    if (eligibility.reason === "already_reviewed") {
      return eligibility.message || this.labels.headerIneligibleNote;
    }

    return "";
  };

  ReviewsSection.prototype.renderSummary = function (summary) {
    if (!summary) {
      return;
    }

    this.updateReviewVisibility(summary.count);

    if (this.summaryAverageNode) {
      this.summaryAverageNode.textContent =
        summary.count > 0 ? summary.average.toFixed(1) : this.noRatingLabel;
    }

    if (this.summaryCountNode) {
      this.summaryCountNode.textContent =
        summary.count > 0 ? formatReviewCount(summary.count, this.locale) : this.noReviewsLabel;
    }

    if (this.sortWrapper) {
      if (summary.count > 1) {
        this.sortWrapper.removeAttribute("hidden");
      } else {
        this.sortWrapper.setAttribute("hidden", "");
      }
    }

    if (this.distributionNode) {
      if (summary.count > 0) {
        this.distributionNode.removeAttribute("hidden");
      } else {
        this.distributionNode.setAttribute("hidden", "");
      }

      Array.prototype.forEach.call(
        this.distributionNode.querySelectorAll("[data-review-distribution-row]"),
        function (row) {
          var rating = Number(row.getAttribute("data-rating"));
          var count = summary.distribution[rating] || 0;
          var fill = row.querySelector("[data-review-distribution-fill]");
          var countNode = row.querySelector("[data-review-distribution-count]");
          var width = summary.count > 0 ? (count / summary.count) * 100 : 0;

          if (fill) {
            fill.style.width = width + "%";
          }

          if (countNode) {
            countNode.textContent = String(count);
          }
        },
      );
    }
  };

  ReviewsSection.prototype.renderReviews = function (reviews, append) {
    var _this = this;

    if (!append) {
      this.listNode.innerHTML = "";
    }

    reviews.forEach(function (review) {
      _this.listNode.appendChild(createReviewCard(review, _this.locale, _this.labels));
    });

    if (this.listWrapperNode && this.listNode.children.length === 0) {
      this.listWrapperNode.setAttribute("hidden", "");
    }
  };

  ReviewsSection.prototype.updateLoadMore = function (paging) {
    this.nextOffset = paging.nextOffset;

    if (!this.loadMoreWrapper || !this.loadMoreButton) {
      return;
    }

    if (paging.hasMore) {
      this.loadMoreWrapper.removeAttribute("hidden");
      this.loadMoreButton.disabled = false;
    } else {
      this.loadMoreWrapper.setAttribute("hidden", "");
    }
  };

  ReviewsSection.prototype.setEligibility = function (eligibility) {
    if (!eligibility) {
      return;
    }

    var headerNote = this.resolveHeaderNote(eligibility);

    if (this.headerNoteNode) {
      if (headerNote) {
        this.headerNoteNode.textContent = headerNote;
        this.headerNoteNode.removeAttribute("hidden");
      } else {
        this.headerNoteNode.setAttribute("hidden", "");
      }
    }

    if (this.cardNoteNode && eligibility.canReview) {
      this.cardNoteNode.textContent = this.labels.formNote;
    }

    if (this.eligibilityMessageNode && !this.formCardNode) {
      this.eligibilityMessageNode.textContent = this.resolveEligibilityMessage(eligibility);
    }

    if (this.formCardNode) {
      if (eligibility.canReview) {
        this.formCardNode.removeAttribute("hidden");
      } else {
        this.formCardNode.setAttribute("hidden", "");
      }
    }

    if (this.formContainer) {
      if (eligibility.canReview) {
        this.formContainer.removeAttribute("hidden");
      } else {
        this.formContainer.setAttribute("hidden", "");
      }
    }

    this.populateOrderOptions(eligibility.orders || []);
  };

  ReviewsSection.prototype.populateOrderOptions = function (orders) {
    this.eligibleOrders = orders || [];

    if (!this.orderSelect) {
      return;
    }

    this.orderSelect.innerHTML = "";

    for (var index = 0; index < this.eligibleOrders.length; index += 1) {
      var order = this.eligibleOrders[index];
      var option = document.createElement("option");
      option.value = order.id;
      option.textContent = order.name + " • " + formatDate(this.locale, order.processedAt);
      this.orderSelect.appendChild(option);
    }

    if (this.orderField) {
      if (this.eligibleOrders.length > 1) {
        this.orderField.removeAttribute("hidden");
        this.orderSelect.required = true;
      } else {
        this.orderField.setAttribute("hidden", "");
        this.orderSelect.required = false;
      }
    }

    if (this.eligibleOrders.length > 0) {
      this.orderSelect.value = this.eligibleOrders[0].id;
    }

    this.updateOrderHint();
  };

  ReviewsSection.prototype.updateOrderHint = function () {
    if (!this.orderHint || !this.orderSelect) {
      return;
    }

    var selectedOrder = null;

    for (var index = 0; index < this.eligibleOrders.length; index += 1) {
      if (this.eligibleOrders[index].id === this.orderSelect.value) {
        selectedOrder = this.eligibleOrders[index];
        break;
      }
    }

    if (!selectedOrder) {
      this.orderHint.textContent = "";
      return;
    }

    if (this.targetType === "product" && selectedOrder.matchingItem) {
      this.orderHint.textContent =
        selectedOrder.matchingItem.productTitle +
        " • " +
        selectedOrder.name +
        " • " +
        formatDate(this.locale, selectedOrder.processedAt);
      return;
    }

    this.orderHint.textContent =
      selectedOrder.name +
      " • " +
      formatDate(this.locale, selectedOrder.processedAt) +
      " • " +
      joinOrderedItems(selectedOrder.orderedItems);
  };

  ReviewsSection.prototype.fetchReviews = async function (append) {
    if (this.isLoading || !this.reviewsUrl) {
      return;
    }

    this.isLoading = true;

    if (this.loadingNode) {
      this.loadingNode.removeAttribute("hidden");
    }

    if (this.loadMoreButton) {
      this.loadMoreButton.disabled = true;
    }

    try {
      var url = new URL(this.reviewsUrl, window.location.origin);
      url.searchParams.set("target", this.targetType);
      url.searchParams.set("sort", this.activeSort);

      if (this.targetType === "product") {
        url.searchParams.set("product_id", this.productId);
      }

      if (append && this.nextOffset > 0) {
        url.searchParams.set("offset", String(this.nextOffset));
      }

      var response = await fetch(url.toString(), {
        headers: {
          Accept: "application/json",
        },
      });
      var data = await parseJsonResponse(response);

      if (!response.ok || !data || !data.ok) {
        throw new Error((data && data.message) || "REVIEWS_UNAVAILABLE");
      }

      this.renderSummary(data.summary);
      this.setEligibility(data.eligibility);
      this.renderReviews(data.reviews, append);
      this.updateLoadMore(data.paging);
      this.isLoaded = true;
    } catch (error) {
      if (this.headerNoteNode) {
        this.headerNoteNode.textContent = this.labels.moduleUnavailable;
        this.headerNoteNode.removeAttribute("hidden");
      }

      if (this.eligibilityMessageNode && !this.formCardNode) {
        this.eligibilityMessageNode.textContent = this.labels.moduleUnavailable;
      }

      if (this.formCardNode) {
        this.formCardNode.setAttribute("hidden", "");
      }

      if (this.formContainer) {
        this.formContainer.setAttribute("hidden", "");
      }

      if (append || this.isLoaded) {
        this.setFeedback(
          normalizeErrorMessage(error, this.labels.loadError),
          "error",
        );
      } else {
        this.clearFeedback();
      }
    } finally {
      this.isLoading = false;

      if (this.loadingNode) {
        this.loadingNode.setAttribute("hidden", "");
      }
    }
  };

  ReviewsSection.prototype.submit = async function () {
    if (!this.formNode || !this.reviewsUrl) {
      return;
    }

    this.clearFeedback();

    if (!this.formNode.reportValidity()) {
      return;
    }

    var submitButton = this.formNode.querySelector('button[type="submit"]');
    var formData = new FormData(this.formNode);

    if (this.orderSelect && this.eligibleOrders.length > 0 && !formData.get("order_id")) {
      formData.set("order_id", this.orderSelect.value);
    }

    submitButton.disabled = true;

    try {
      var response = await fetch(this.reviewsUrl, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });
      var data = await parseJsonResponse(response);

      if (!response.ok || !data || !data.ok) {
        throw new Error((data && data.message) || "REVIEWS_UNAVAILABLE");
      }

      this.setFeedback(data.message, "success");
      this.formNode.reset();
      await this.fetchReviews(false);
    } catch (error) {
      this.setFeedback(
        normalizeErrorMessage(error, this.labels.submitError),
        "error",
      );
    } finally {
      submitButton.disabled = false;
    }
  };

  function mount(root) {
    if (!root || root.dataset.reviewsMounted === "true") {
      return;
    }

    root.dataset.reviewsMounted = "true";
    new ReviewsSection(root);
  }

  function mountAll(container) {
    Array.prototype.forEach.call(
      container.querySelectorAll("[data-review-root]"),
      function (root) {
        mount(root);
      },
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      mountAll(document);
    });
  } else {
    mountAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    mountAll(event.target);
  });
})();
